(() => {
  if (window.__comparativeTableBound) return;
  window.__comparativeTableBound = true;
  window.__airmPairs = window.__airmPairs || {};

  const resolveCarousel = (pairId) => {
    return (
      (window.__airmPairs && window.__airmPairs[pairId]) ||
      document.querySelector(`diffusers-carousel[data-pair-id="${CSS.escape(pairId)}"]`)
    );
  };

  const activate = (pairId, slideKey) => {
    const carousel = resolveCarousel(pairId);
    if (!carousel) {
      if (window.Shopify && window.Shopify.designMode) {
        console.warn(`[comparative-table] no carousel found for pair "${pairId}"`);
      }
      return;
    }
    if (typeof carousel.goToSlideKey === 'function') {
      carousel.goToSlideKey(slideKey);
    }
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-target-slide]');
    if (!btn) return;
    const pairId = btn.dataset.targetPair;
    const slideKey = btn.dataset.targetSlide;
    if (!pairId || !slideKey) return;
    event.preventDefault();
    activate(pairId, slideKey);
  });

  const parseHash = () => {
    const raw = (window.location.hash || '').replace(/^#/, '');
    if (!raw) return null;
    const params = new URLSearchParams(raw);
    const pairId = params.get('pair');
    const slideKey = params.get('slide');
    if (!pairId || !slideKey) return null;
    return { pairId, slideKey };
  };

  const handleHash = () => {
    const parsed = parseHash();
    if (!parsed) return;
    activate(parsed.pairId, parsed.slideKey);
  };

  window.addEventListener('hashchange', handleHash);

  const deepLinkOnReady = () => {
    const parsed = parseHash();
    if (!parsed) return;
    let attempts = 0;
    const tick = () => {
      attempts += 1;
      if (resolveCarousel(parsed.pairId)) {
        activate(parsed.pairId, parsed.slideKey);
      } else if (attempts < 20) {
        setTimeout(tick, 100);
      }
    };
    tick();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deepLinkOnReady);
  } else {
    deepLinkOnReady();
  }
})();
